import State from 'store/State';
import { StreamedDataState } from 'streamsState/store/streamedData/StreamedDataState';
import { selectStreamState } from 'streamsState/store/selectors';

export const selectStreamedDataState: (state: State) => StreamedDataState = (
    state
) => selectStreamState(state).data;
